module.exports = __webpack_public_path__ + "static/media/progress.e539645e.svg";